import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import has from 'lodash/has';
import each from 'lodash/each';

// A counter used to generate a unique id for each component that uses the function
let idCount = 0;
const SCRIPT_MAP = {};

/*
 The commented out logic is logic not supported by IE10 or IE11. I left as a reference
 in case issues occur with the polyfills.
*/

export default function makeAsyncScript(Component, scriptURL, options = {}) {
    const funcs = {
        displayName: 'AsyncScriptLoader',

        propTypes: {
            asyncScriptOnLoad: PropTypes.func,
        },

        statics: {
            asyncScriptLoaderTriggerOnScriptLoaded() {
                const mapEntry = SCRIPT_MAP[scriptURL];

                if (!mapEntry || !mapEntry.loaded) {
                    throw new Error('Script is not loaded.');
                }

                // for (let observer of _.values(mapEntry.observers)) {
                //     observer(mapEntry);
                // }
                each(mapEntry.observers, (observer) => observer(mapEntry));

                delete window[options.callbackName];
            },
        },

        getInitialState() {
            return {};
        },

        asyncScriptLoaderGetScriptLoaderID() {
            if (!this.__scriptLoaderID) {
                this.__scriptLoaderID = `async-script-loader-${idCount++}`;
            }

            return this.__scriptLoaderID;
        },

        getComponent() {
            return this.childComponent;
        },

        componentDidMount() {
            const key = this.asyncScriptLoaderGetScriptLoaderID();
            const { globalName, callbackName } = options;

            if (globalName && typeof window[globalName] !== 'undefined') {
                SCRIPT_MAP[scriptURL] = { loaded: true, observers: {} };
            }

            if (has(SCRIPT_MAP, scriptURL)) {
                const entry = SCRIPT_MAP[scriptURL];

                if (entry && (entry.loaded || entry.errored)) {
                    this.asyncScriptLoaderHandleLoad(entry);
                    return;
                }
                entry.observers[key] = this.asyncScriptLoaderHandleLoad;
                return;
            }

            const observers = {};

            observers[key] = this.asyncScriptLoaderHandleLoad;
            SCRIPT_MAP[scriptURL] = {
                observers,
                loaded: false,
            };

            const script = document.createElement('script');

            script.src = scriptURL;
            script.async = 1;

            const callObserverFuncAndRemoveObserver = (func) => {
                if (has(SCRIPT_MAP, scriptURL)) {
                    const mapEntry = SCRIPT_MAP[scriptURL];
                    const observersMap = mapEntry.observers;
                    const newMap = {};

                    // for (let [obsKey, observer] of observersMap) {
                    //     if (func(observer)) {
                    //         observersMap.delete(obsKey);
                    //     }
                    // }

                    each(observersMap, (observer, observerKey) => {
                        if (!func(observer)) {
                            newMap[observerKey] = observer;
                        }
                    });

                    mapEntry.observers = newMap;
                }
            };

            if (callbackName && typeof window !== 'undefined') {
                //eslint-disable-next-line
                window[callbackName] =
                    AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded;
            }

            script.onload = () => {
                const mapEntry = SCRIPT_MAP[scriptURL];

                if (mapEntry) {
                    mapEntry.loaded = true;

                    callObserverFuncAndRemoveObserver((observer) => {
                        if (callbackName) {
                            return false;
                        }

                        observer(mapEntry);
                        return true;
                    });
                }
            };
            script.onerror = () => {
                const mapEntry = SCRIPT_MAP[scriptURL];

                if (mapEntry) {
                    mapEntry.errored = true;
                    callObserverFuncAndRemoveObserver((observer) => {
                        observer(mapEntry);
                        return true;
                    });
                }
            };

            // (old) MSIE browsers may call 'onreadystatechange' instead of 'onload'
            script.onreadystatechange = () => {
                if (this.readyState === 'loaded') {
                    // wait for other events, then call onload if default onload hadn't been called
                    window.setTimeout(() => {
                        const mapEntry = SCRIPT_MAP[scriptURL];

                        if (mapEntry && mapEntry.loaded !== true) {
                            script.onload();
                        }
                    }, 0);
                }
            };

            document.body.appendChild(script);
        },

        asyncScriptLoaderHandleLoad(state) {
            this.setState(state, this.props.asyncScriptOnLoad);
        },

        componentWillUnmount() {
            // Remove tag script
            if (options.removeOnUnmount === true) {
                const allScripts = document.getElementsByTagName('script');

                for (let i = 0; i < allScripts.length; i += 1) {
                    if (allScripts[i].src.indexOf(scriptURL) > -1) {
                        if (allScripts[i].parentNode) {
                            allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                }
            }
            // Clean the observer entry
            const mapEntry = SCRIPT_MAP[scriptURL];

            if (mapEntry) {
                // mapEntry.observers.delete(this.asyncScriptLoaderGetScriptLoaderID());
                const scriptLoaderId = this.asyncScriptLoaderGetScriptLoaderID();

                delete mapEntry.observers[scriptLoaderId];

                if (options.removeOnUnmount === true) {
                    // SCRIPT_MAP.delete(scriptURL);
                    delete SCRIPT_MAP[scriptURL];
                }
            }
        },

        render() {
            const globalName = options.globalName;
            //eslint-disable-next-line
            let { asyncScriptOnLoad, ...childProps } = this.props;

            if (globalName && typeof window !== 'undefined') {
                childProps[globalName] =
                    typeof window[globalName] !== 'undefined'
                        ? window[globalName]
                        : undefined;
            }
            //eslint-disable-next-line
            return (
                <Component
                    ref={(comp) => {
                        this.childComponent = comp;
                    }}
                    {...childProps}
                />
            );
        },
    };

    if (options.exposeFuncs) {
        // for (let funcToExpose of options.exposeFuncs) {
        //   /* eslint-disable no-loop-func */
        //     funcs[funcToExpose] = function() {
        //         return this.childComponent[funcToExpose](...arguments);
        //     };
        //   /* eslint-enable no-loop-func */
        // }
        each(options.exposeFuncs, (funcToExpose) => {
            funcs[funcToExpose] = function () {
                //eslint-disable-next-line
                return this.childComponent[funcToExpose](...arguments);
            };
        });
    }

    const AsyncScriptLoader = createReactClass(funcs);

    return AsyncScriptLoader;
}
